import {
  CSB,
  SIB,
  FED,
  BOB,
  SBM,
  CSBIMAGE1LINK,
  CSBIMAGE2LINK,
  CSBIMAGEMOBILEVIEWLINK,
  BOBIMAGE1LINK,
  BOBIMAGE2LINK,
  BOBIMAGEMOBILEVIEWLINK,
  SBMIMAGE1LINK,
  SBMIMAGE2LINK,
  SBMIMAGEMOBILEVIEWLINK,
  SIBIMAGE1LINK,
  SIBIMAGE2LINK,
  SIBIMAGEMOBILEVIEWLINK,
  FEDIMAGE1LINK,
  FEDIMAGE2LINK,
  FEDIMAGEMOBILEVIEWLINK,
  ALLBANKSIMAGE1LINK,
  ALLBANKSIMAGE2LINK,
  ALLBANKMOBILEVIEWLINK,
  IDIBIMAGE1LINK,
  IDIBIMAGE2LINK,
  IDIBIMAGEMOBILEVIEWLINK,
  IDIB,
} from './constants';

export interface imageLinksObjectType {
  image1Link: string;
  image2Link: string;
  imageMobileViewLink: string;
}

export function selectImagesAccordingToBank(bankName: string) {
  let image1Link = '';
  let image2Link = '';
  let imageMobileViewLink = '';

  switch (bankName) {
    case CSB:
      image1Link = CSBIMAGE1LINK;
      image2Link = CSBIMAGE2LINK;
      imageMobileViewLink = CSBIMAGEMOBILEVIEWLINK;
      break;
    case BOB:
      image1Link = BOBIMAGE1LINK;
      image2Link = BOBIMAGE2LINK;
      imageMobileViewLink = BOBIMAGEMOBILEVIEWLINK;
      break;
    case SBM:
      image1Link = SBMIMAGE1LINK;
      image2Link = SBMIMAGE2LINK;
      imageMobileViewLink = SBMIMAGEMOBILEVIEWLINK;
      break;
    case SIB:
      image1Link = SIBIMAGE1LINK;
      image2Link = SIBIMAGE2LINK;
      imageMobileViewLink = SIBIMAGEMOBILEVIEWLINK;
      break;
    case FED:
      image1Link = FEDIMAGE1LINK;
      image2Link = FEDIMAGE2LINK;
      imageMobileViewLink = FEDIMAGEMOBILEVIEWLINK;
      break;
    case IDIB:
      image1Link = IDIBIMAGE1LINK;
      image2Link = IDIBIMAGE2LINK;
      imageMobileViewLink = IDIBIMAGEMOBILEVIEWLINK;
      break;
    default:
      image1Link = ALLBANKSIMAGE1LINK;
      image2Link = ALLBANKSIMAGE2LINK;
      imageMobileViewLink = ALLBANKMOBILEVIEWLINK;
      break;
  }
  return {
    image1Link,
    image2Link,
    imageMobileViewLink,
  };
}
